@let content = mappedContent();
@if (content.items?.length > 0) {
  <div>
    @if (content.teaserTitle) {
      <h2>{{ content.teaserTitle }}</h2>
    }
    <div class="promo-cards fill grid-col-12 no-gutters" [class.full-width]="content.items?.length === 1">
      @for (item of content.items.slice(0, 3); track $index) {
        <fcom-promo-card
          [data]="item"
          [imageData]="item.picture"
          [ctaData]="item?.target"
          [fullWidth]="content.items?.length === 1"
          [analyticsEventName]="'marketing-activity-block-cta'"
        />
      }
    </div>
  </div>
}
